// The three environments that EventOPS can serve the widget from.
export const ENV_PRODUCTION = 'production';
export const ENV_BETA = 'beta';
export const ENV_STAGING = 'staging';

// These are the URLs that the widget can be loaded from
export const URL_PRODUCTION = 'https://app.eventops.software/splash/widget.js';
export const URL_BETA = 'https://beta.eventops.software/splash/widget.js';
export const URL_STAGING = 'https://stewart.inapp.com/splash/widget.js';

export const WIDGET_URL_BY_ENV = {
    [ENV_PRODUCTION]: URL_PRODUCTION,
    [ENV_BETA]: URL_BETA,
    [ENV_STAGING]: URL_STAGING,
};
